import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=aca162f8&scoped=true"
import script from "./FormItem.vue?vue&type=script&lang=js"
export * from "./FormItem.vue?vue&type=script&lang=js"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=aca162f8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca162f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aca162f8')) {
      api.createRecord('aca162f8', component.options)
    } else {
      api.reload('aca162f8', component.options)
    }
    module.hot.accept("./FormItem.vue?vue&type=template&id=aca162f8&scoped=true", function () {
      api.rerender('aca162f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/TableForm/FormItem.vue"
export default component.exports